import {
  SET_TANK_STATISTIC,
  SET_TANK_STATISTIC_FILTER,
  SET_TANK_STATISTIC_LOADED,
  TankStatisticAction,
  TankStatisticState,
} from '../types'

const inititalState: TankStatisticState = {
  tankStatistic: [],
  isTankStatisticLoaded: false,
  tankStatisticFilter: {
    startTime: new Date(new Date().setDate(1)).getTime(),
    endTime: new Date().getTime(),
  },
}

export const tankStatisticReducer = (
  state = inititalState,
  action: TankStatisticAction
): TankStatisticState => {
  switch (action.type) {
    case SET_TANK_STATISTIC:
      return {
        ...state,
        tankStatistic: action.payload,
      }
    case SET_TANK_STATISTIC_LOADED:
      return {
        ...state,
        isTankStatisticLoaded: action.payload,
      }
    case SET_TANK_STATISTIC_FILTER:
      return {
        ...state,
        tankStatisticFilter: action.payload,
      }
    default:
      return state
  }
}
